<template>
    <ul class="x-pro-ul" >
        <li class="x-pro-li"  v-for="pro in pro_items">
            <a :href="pro.href">
                <div class="pro-img">
                    <img :src="pro.url" alt="">
                    <div class="ewm"><img :src=" '/static/images/'+pro.ewm" alt=""></div>
                </div>
                <p class="x-pro-time"><span>小九</span>  2017-09-08</p>
                <h2 class="x-pro-title t-o-e-y">{{ pro.title }}</h2>
                <p class="x-pro-text t-o-e-n-3">{{ pro.text }}</p>
            </a>
        </li>
    </ul>
</template>

<script>

    const host = 'https://chinajiu.github.io/code/'

    export default {
        data(){
            return{
                pro_items: [
                    { url:'https://xproject.oss-cn-beijing.aliyuncs.com/myblog/project/g1.gif',title:'时光胶囊',href: host + 'H9/',text:'一粒当代给未来的时光胶囊',ewm:'H9.png' },
                    { url:'https://xproject.oss-cn-beijing.aliyuncs.com/myblog/project/newp-1.jpg',title:'中秋月饼',href: host + 'H1/',text:'五仁月饼',ewm:'H1.png' },
                    { url:'https://xproject.oss-cn-beijing.aliyuncs.com/myblog/project/g9.gif',title:'打地鼠',href: host + 'H4/',text:'"鸡"不可失',ewm:'H4.png' },
                    { url:'https://xproject.oss-cn-beijing.aliyuncs.com/myblog/project/g11.gif',title:'金茂杂志',href: host + 'H5/',text:'实至名归，不负金茂之名',ewm:'H5.png' },
                    { url:'https://xproject.oss-cn-beijing.aliyuncs.com/myblog/project/newp-2.jpg',title:'国瑞',href: host + 'H6/',text:'国瑞熙墅',ewm:'H6.png' },
                    { url:'https://xproject.oss-cn-beijing.aliyuncs.com/myblog/project/g2.gif',title:'寻宝大作战',href: host + 'H2/',text:'寻宝大作战，欢乐好礼送',ewm:'H2.png' },
                    { url:'https://xproject.oss-cn-beijing.aliyuncs.com/myblog/project/g10.gif',title:'金茂有书声',href: host + 'H8/',text:'金茂府理想有书声',ewm:'H8.png' },
                    { url:'https://xproject.oss-cn-beijing.aliyuncs.com/myblog/project/newp-3.jpg',title:'圣诞节',href: host + 'H10/',text:'圣诞节',ewm:'H10.png' },
                    { url:'https://xproject.oss-cn-beijing.aliyuncs.com/myblog/project/newp-4.jpg',title:'远洋',href: host + 'H3/',text:'健康生活家',ewm:'H3.png' },
                ]
            }
        },
        methods: {

        }
    }
</script>

<style scoped>
.x-pro-ul{width: 1060px; margin: -30px 100px 0 50px; display: -webkit-flex; display: flex; flex-wrap:wrap;}
.x-pro-li{width: 300px;  margin-left: 50px; margin-top: 30px;}
.pro-img{width: 100%; height: 200px; border-box: none; border-radius: 10px; overflow: hidden; display: flex; justify-content: center; align-items:center; }
.ewm{ position: absolute; left: 0; top:0; width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; background-color: rgba(0,0,0,.3)}
.ewm>img{height:80%;}
.x-pro-time{width: 100%; text-align: left; color: #aaa; letter-spacing: 1px; margin-top: 10px; margin-bottom: 5px; font-weight: bold;}
.x-pro-time>span{color:#62bbc3; letter-spacing: 1px;}
.x-pro-title{width: 100%; text-align: left; color: #555; letter-spacing: 1px;}
.x-pro-text{width: 100%; text-align: left; color: #aaa; font-size: 16px; margin-top: 10px;}

/*S  项目图片放大 滤镜效果*/
.pro-img>img{
    /*filter: saturate(0%);  -webkit-filter: saturate(0%);*/
    transform: scale(1);
    transition: all 1s cubic-bezier(0.18, 0.89, 0.17, 0.88);
}
.pro-img>img:hover{
    transform: scale(1.2);
}

/*E  项目图片放大 滤镜效果*/

/*S  项目框缩小*/
.pro-img{
    transform: scale(1);
    transition: all 1s cubic-bezier(0.18, 0.89, 0.17, 0.88);
}
.pro-img:hover{
    filter: saturate(100%);  -webkit-filter: saturate(100%);
    transform: scale(.9);
}
/*E  项目框缩小*/

/*S  二维码*/
.ewm{
    opacity: 0;
    transition: all 1s cubic-bezier(0.18, 0.89, 0.17, 0.88);
}
.ewm:hover{
    opacity: 1;
}
/*S  二维码*/

.x-pro-li h2{
    transition: all 1s cubic-bezier(0.18, 0.89, 0.17, 0.88);
}
.x-pro-li:hover h2{
    color: #62bbc3;
}

/*S 单行文本的溢出显示省略*/
.t-o-e-y{text-overflow:ellipsis; white-space:nowrap; overflow: hidden;}
/*E 单行文本的溢出显示省略*/

/*S 多行文本溢出显示省略号*/
.t-o-e-n-3{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
}
/*E 多行文本溢出显示省略号*/

/*S  屏幕小于880px*/
@media screen and (max-width: 1100px){
    .x-pro-ul{width: 700px; margin: 0 auto;}
}
/*E  屏幕小于880px*/

/*S  屏幕小于640px*/
@media screen and (max-width: 640px){
    .x-pro-ul{width: 100%; margin: 0 auto;}
    .x-pro-li{width: 90%; min-width: 400px; margin: 40px auto 0px; border: 1px solid #eee; border-radius: 20px; padding: 20px 10px; overflow: hidden;}
    .pro-img{height: 300px;}
    .pro-img>img{filter: saturate(100%); width: 100%; transform: scale(1);}
    .x-pro-title{color: #62bbc3}
}
/*E  屏幕小于640*/
</style>


// WEBPACK FOOTER //
// src/components/content/production.vue